export var minZero = function minZero(n) {
  return n >= 0 ? n : 0;
};
export var roundFloat = function roundFloat(value) {
  return Math.round((value + 0.00001) * 100) / 100;
};